<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="575">
    <v-form ref="form" class="white pa-8">
      <v-row class="mb-5">
        <v-col cols="12">
          <p class="text-h6 font-weight-bold primary--text mb-2">
            RENOVAR LIMITE DE CRÉDITO
          </p>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-6">
          <BaseFormInput
            id-element="advisory-02"
            placeholder="DD/MM/YYYY"
            v-model="form.inicio_validade"
            required
            :rules="[requiredInput, dateTermValid]"
            v-facade="maskDate"
            validate-on-blur
            label-text="Validade de"
          />
        </v-col>
        <v-col cols="12" sm="6">
          <BaseFormInput
            id-element="advisory-03"
            placeholder="DD/MM/YYYY"
            v-model="form.final_validade"
            required
            :rules="[requiredInput, dateTermValid]"
            v-facade="maskDate"
            validate-on-blur
            label-text="Até"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="3" xl="2" class="pr-2">
          <BaseButton
            v-html="'CANCELAR'"
            outlined
            color="secondary"
            width="100%"
            @click="$emit('close', false)"
          />
        </v-col>
        <v-col cols="3" xl="2">
          <BaseButton
            v-html="'RENOVAR'"
            class="secondary"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </v-form>
  </v-dialog>
</template>
<script>
import { requiredInput, dateTermValid } from "@/utils/rules.js";
import { maskDate } from "@/utils/masks.js";
export default {
  data: () => ({
    requiredInput,
    dateTermValid,
    maskDate
  }),
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("close", true);
    }
  },
  props: {
    form: {
      type: Object
    }
  }
};
</script>
